export function ExcelUploadLoadError(error) {
    const msg = (error?.message ?? "").toLowerCase()

    if (msg.includes("password") || msg.includes("encrypted")) {
        return "This file appears to be password-protected. Please remove the password in Excel and try again."
    }

    if (
        msg.includes("end of central directory") ||
        msg.includes("invalid zip") ||
        msg.includes("not a valid zip") ||
        msg.includes("corrupted zip") ||
        msg.includes("bad local file header") ||
        msg.includes("unexpected end of data")
    ) {
        return "This file could not be read. It may be corrupt or not a valid Excel (.xlsx) file. Please check the file opens correctly in Excel and try again."
    }

    if (msg.includes("no worksheets")) {
        return "This file contains no worksheets. Please check the file and try again."
    }

    if (msg.includes("unsupported") || msg.includes("not supported")) {
        return "This file format is not supported. Please save it as an .xlsx file in Excel and try again."
    }

    const detail = error?.message ? `: ${error.message}` : ""
    return `Could not read this file${detail}. Please ensure it is a valid .xlsx file.`
}
